export default __webpack_public_path__ + "static/media/spa-image-03.2d18c2bf.png";